import React from "react";
import style from "./ProductSelector.module.scss";
import { Modal } from "../../../secondary";
import AssessmentStep from "./AssessmentStep";
import ProductResults from "./ProductResults";
import { useProductSelector } from "./hooks/useProductSelector";
import ResultDetail from "./ResultDetail";
import { useRequestMoreInfo } from "../hooks/useRequestMoreInfo";
import { MaterialDetailView } from "../Products/MaterialDetailView";
import { ProductDetailSkeleton } from "../Products/ProductDetailSkeleton";
import { getModalHeading, VIEW } from "./utils";

export const ProductSelector = ({ modalOpen, onClose }) => {
  const {
    steps,
    activeIndex,
    loading,
    view,
    isComplete,
    formularyData,
    cardLoading,
    detailLoading,
    detailTitle,
    detailGroups,
    materialLoading,
    materialDetail,
    selectedProductId,
    selectedMaterialId,
    selectAnswer,
    startEdit,
    submitAssessment,
    openCategoryDetail,
    backToResults,
    openMaterialDetail,
    handleBackToResultDetail,
    backToAssessment,
    reset,
  } = useProductSelector();

  const { moreInfoLoading, reqSuccessMessage, setReqSuccessMessage, handleRequestMoreInfo } = useRequestMoreInfo({
    selectedProductId,
    selectedMaterialId,
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleOpenMaterial = (productCategoryId, materialId) => {
    setReqSuccessMessage(null);
    openMaterialDetail(productCategoryId, materialId);
  };

  return (
    <Modal
      modalOpen={modalOpen}
      modalClose={handleClose}
      heading={getModalHeading(view, detailTitle)}
      modalSize={style.custom_modal_size}
      custom_heading="pt-0"
    >
      <div className={style.viewport} key={view}>
        {view === VIEW.ASSESSMENT && (
          <>
            <div className={style.steps}>
              {steps.map((step, index) => (
                <AssessmentStep
                  key={index}
                  step={step}
                  index={index}
                  isActive={index === activeIndex}
                  isLoading={loading && index === activeIndex}
                  onSelect={selectAnswer}
                  onEdit={startEdit}
                />
              ))}
            </div>

            {isComplete && (
              <div className={style.submit_row}>
                <button type="button" className={style.submit_btn} onClick={submitAssessment}>
                  Submit
                </button>
              </div>
            )}
          </>
        )}

        {view === VIEW.RESULTS && (
          <ProductResults formularyData={formularyData} cardLoading={cardLoading} onCategorySelect={openCategoryDetail} onBack={backToAssessment} />
        )}

        {view === VIEW.RESULT_DETAIL && (
          <ResultDetail groups={detailGroups} loading={detailLoading} onBack={backToResults} onMaterialSelect={handleOpenMaterial} />
        )}

        {view === VIEW.MATERIAL_DETAIL_VIEW && (
          <>
            {materialLoading && !materialDetail && <ProductDetailSkeleton />}

            {materialDetail && (
              <MaterialDetailView
                material={materialDetail}
                onBack={handleBackToResultDetail}
                onRequestMoreInfo={handleRequestMoreInfo}
                successMessage={reqSuccessMessage}
                loading={moreInfoLoading}
              />
            )}
          </>
        )}
      </div>
    </Modal>
  );
};
